import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=2510e6b2&scoped=true&"
import script from "./Tools.vue?vue&type=script&lang=ts&"
export * from "./Tools.vue?vue&type=script&lang=ts&"
import style0 from "./Tools.vue?vue&type=style&index=0&id=2510e6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510e6b2",
  null
  
)

export default component.exports